import en from './langs/en'
import zh from './langs/zh'
export default {
  en: en,
  zh: zh
}



// WEBPACK FOOTER //
// ./src/assets/i18n/index.js